import React from 'react';
import { BookOpenIcon, ListIcon, CalendarIcon, ClipboardListIcon, HelpCircleIcon, ZapIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferDetails() {
  const includes = [{
    icon: BookOpenIcon,
    text: 'The full 10-chapter eBook'
  }, {
    icon: ListIcon,
    text: 'The anti-inflammatory grocery list'
  }, {
    icon: CalendarIcon,
    text: 'The 14-day mix-and-match meal templates'
  }, {
    icon: ClipboardListIcon,
    text: 'Daily habit trackers'
  }, {
    icon: HelpCircleIcon,
    text: 'Troubleshooting guides'
  }, {
    icon: ZapIcon,
    text: 'A quick-start summary page to get going right away'
  }];
  return <section id="offer" className="py-20 md:py-32 bg-cream-light" data-id="element-105">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-cream-dark flex flex-col md:flex-row" data-id="element-107">
          {/* Left Column - Price & Value */}
          <div className="bg-sage-dark text-white p-10 md:p-12 md:w-2/5 flex flex-col justify-center items-center text-center" data-id="element-108">
            <span className="inline-block bg-white/20 text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-109">
              Limited-Time Offer
            </span>
            <p className="text-sage-light font-semibold tracking-wider uppercase mb-2" data-id="element-110">
              Instant Access
            </p>
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-111">
              <span className="text-2xl text-white/50 line-through" data-id="element-112">$27</span>
              <h3 className="text-5xl md:text-6xl font-bold" data-id="element-113">
                <span className="text-2xl align-top" data-id="element-114">$</span>9
                <span className="text-3xl" data-id="element-115">.38</span>
              </h3>
            </div>
            <p className="text-sm text-sage-light font-medium mb-1" data-id="element-116">
              You save over 65%
            </p>
            <p className="text-lg text-white/90 leading-relaxed mb-8" data-id="element-117">
              You'll get the full "14-Day Belly Reset" digital guide. No fluff,
              no complicated rules—just a practical, step-by-step plan ready to
              use right now.
            </p>
            <a href="https://wellnessresetzone.com/cart/47635769327668:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full inline-flex justify-center items-center px-8 py-4 text-lg font-bold rounded-full text-sage-dark bg-white hover:bg-cream-light shadow-lg transition-all hover:-translate-y-0.5" data-id="element-118">
              Get It Now
            </a>
          </div>

          {/* Right Column - What's Included */}
          <div className="p-10 md:p-12 md:w-3/5" data-id="element-119">
            <h4 className="text-2xl font-bold text-ink mb-8 font-serif border-b border-cream-dark pb-4" data-id="element-120">
              Here's exactly what's inside:
            </h4>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-121">
              {includes.map((item, index) => {
              const Icon = item.icon;
              return <li key={index} className="flex items-start" data-id="element-122">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-sage-light/20 flex items-center justify-center mr-4" data-id="element-123">
                      <Icon className="h-5 w-5 text-sage-dark" aria-hidden="true" data-id="element-124" />
                    </div>
                    <span className="text-ink/80 font-medium mt-2" data-id="element-125">
                      {item.text}
                    </span>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}